import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  IGIframe,
  IGPrizeDelivery,
  IGPrizeList,
  IGResponse,
  IGResponseTickets,
  PrizeSiteCredit
} from '@core/models';
import { Observable } from 'rxjs';
import { API_LIST } from '../web-api/api-list';

@Injectable({
  providedIn: 'root'
})
export class IgamingService {
  constructor(private httpClient: HttpClient) {}

  getPrizeList(
    gameId: number,
    limit: number = 100,
    page: number = 1
  ): Observable<IGResponse<IGPrizeList>> {
    return this.httpClient.get<IGResponse<IGPrizeList>>(
      API_LIST.getIGPrizeList(gameId, limit, page)
    );
  }

  getPrizeDeliverySlugs(
    raffleId: number
  ): Observable<IGResponse<IGPrizeDelivery>> {
    return this.httpClient.get<IGResponse<IGPrizeDelivery>>(
      API_LIST.getIGPrizeDeliverySlugs(raffleId)
    );
  }

  getPrizeDeliveryByOrderId(
    orderId: number
  ): Observable<IGResponse<IGPrizeDelivery>> {
    return this.httpClient.get<IGResponse<IGPrizeDelivery>>(
      API_LIST.getIGPrizeDeliveryByOrderId(orderId)
    );
  }

  startGameSessionByRaffleId(
    raffleId: number
  ): Observable<IGResponse<IGIframe>> {
    return this.httpClient.get<IGResponse<IGIframe>>(
      API_LIST.startGameSessionByTicketId(raffleId),
      {}
    );
  }

  getUnplayedTickets(
    gameId: number,
    token: string
  ): Observable<IGResponse<{ count: number }>> {
    return this.httpClient.get<IGResponse<{ count: number }>>(
      API_LIST.getUnplayedTickets(gameId),
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
  }

  patchCompleteSession(sessionId: string): Observable<IGResponse<IGIframe>> {
    return this.httpClient.patch<IGResponse<IGIframe>>(
      API_LIST.patchCompleteSession(sessionId),
      {}
    );
  }

  getPrizeSiteCredits(
    prizes: number[]
  ): Observable<IGResponse<PrizeSiteCredit[]>> {
    return this.httpClient.get<IGResponse<PrizeSiteCredit[]>>(
      API_LIST.getPrizeSiteCredits(prizes),
      {}
    );
  }

  getTicketsByOrderId(
    orderId: number
  ): Observable<IGResponse<IGResponseTickets>> {
    return this.httpClient.get<IGResponse<IGResponseTickets>>(
      API_LIST.getTicketsByOrderId(orderId),
      {}
    );
  }
}
